export default __webpack_public_path__ + "static/media/services10.6861d03a.jpg";